// extracted by mini-css-extract-plugin
module.exports = {"list":"CreatedByInfo_list__2GpXa"};